import styled from 'styled-components';
import fontSettings from '@sdk/theme/fonts';
import PencilSVG from '@sdk/assets/svg/UI/pencil.svg';
import ReplySVG from '@sdk/assets/svg/UI/reply.svg';
import RingbellSVG from '@sdk/assets/svg/UI/ringbell.svg';
import TrashSVG from '@sdk/assets/svg/UI/trash.svg';
import BaseIconSvg from '@sdk/components/ui/BaseIconSvg';

export const PencilIcon = styled(BaseIconSvg)``;
PencilIcon.defaultProps = {
  as: PencilSVG,
};
export const ReplyIcon = styled(BaseIconSvg)``;
ReplyIcon.defaultProps = {
  as: ReplySVG,
};
export const RingbellIcon = styled(BaseIconSvg)``;
RingbellIcon.defaultProps = {
  as: RingbellSVG,
};
export const TrashIcon = styled(BaseIconSvg)``;
TrashIcon.defaultProps = {
  as: TrashSVG,
};

export const Button = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: flex;
  font: normal 400 16px/1 ${fontSettings.fontFamily};
  gap: 3px;
  height: 24px;
  justify-content: center;
  min-width: 24px;
  padding: 0;
  pointer-events: auto;
  transition: color 0.25s linear;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
  &:hover ${TrashIcon} {
    color: ${({ theme }) => theme.colors.danger};
  }
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.boxShadows.bottomLight};
  padding: 3px;
  display: flex;
  flex-flow: row nowrap;
  width: min-content;
`;
